// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.top-bottom-instruments-light-widget{height:100%}`, "",{"version":3,"sources":["webpack://./src/elements/report-widgets/top-bottom-instruments-light-widget/top-bottom-instruments-light-widget.scss"],"names":[],"mappings":"AAAA,qCAAqC,WAAW","sourcesContent":[".top-bottom-instruments-light-widget{height:100%}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
